document.addEventListener('DOMContentLoaded', function() {
	
	const isMobileDevice = () => window.matchMedia('(max-width: 767px)').matches;
	const setVh = () => {
		// Only set --vh on desktop - mobile uses dvh directly in CSS
		if (!isMobileDevice()) {
			document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
		}
	};
	setVh();
	window.addEventListener('resize', setVh);
	window.addEventListener('orientationchange', () => { 
		// On orientation change, wait a bit then set --vh if we're now on desktop
		setTimeout(() => {
			if (!isMobileDevice()) {
				setVh();
			}
		}, 100); 
	});

	function cssEscape(val) {
		try {
			if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(val);
		} catch (e) {
			// no-op
		}
		return String(val).replace(/[^a-zA-Z0-9_\-]/g, function (ch) {
			return '\\' + ch;
		});
	}

	function initStickyBar() {
		document.querySelectorAll('[data-ymee-sticky-bar][data-section-id]').forEach((bar) => {
			if (bar.dataset.ymeeStickyBound === 'true') return;
			bar.dataset.ymeeStickyBound = 'true';

			const barHome = { parent: bar.parentElement, next: bar.nextSibling };

			const sectionId = bar.getAttribute('data-section-id');
			if (!sectionId) return;

			const sectionSelector = `.product-template[data-section-id="${cssEscape(sectionId)}"]`;
			const sectionRoot = bar.closest(sectionSelector) || document.querySelector(sectionSelector) || document;
			const formEl = sectionRoot.querySelector(`#AddToCartForm--${cssEscape(sectionId)}`);

			const colorVariantsEl = sectionRoot.querySelector('.product__meta__color-variants--container');
			const colorMount = bar.querySelector('[data-ymee-sticky-color-variants-mount]');
			const dropdownMount = bar.querySelector('[data-ymee-sticky-variant-dropdown-mount]');

			const colorHome = colorVariantsEl
				? { parent: colorVariantsEl.parentElement, next: colorVariantsEl.nextSibling }
				: null;
			let dropdownEl = null;
			let dropdownHome = null;
			function resolveDropdown() {
				if (dropdownEl && document.contains(dropdownEl)) return dropdownEl;
				// Prefer the current section id so we don't accidentally grab quick-buy/drawer dropdowns.
				dropdownEl =
					sectionRoot.querySelector(
						`.ymee-variant-dropdown[data-ymee-variant-dropdown][data-section-id="${cssEscape(sectionId)}"]`
					) || sectionRoot.querySelector('.ymee-variant-dropdown[data-ymee-variant-dropdown]');
				if (dropdownEl && !dropdownHome) {
					dropdownHome = { parent: dropdownEl.parentElement, next: dropdownEl.nextSibling };
				}
				return dropdownEl;
			}

			let openRaf = 0;
			let openThreshold = 0;
			function computeOpenThreshold() {
				openThreshold = Math.round(window.innerHeight * 0.9);
			}

			let footerObserver = null;
			function bindFooterObserver() {
				try {
					if (footerObserver) footerObserver.disconnect();
				} catch (e) {
					// no-op
				}
				footerObserver = null;
				bar.classList.remove('at-footer');

				const mq = window.matchMedia('(min-width: 1025px)');
				if (!mq.matches) return;

				const footerEl = document.querySelector('.site-footer');
				if (!footerEl || typeof IntersectionObserver === 'undefined') return;

				footerObserver = new IntersectionObserver(
					function (entries) {
						const isIntersecting = entries && entries[0] ? !!entries[0].isIntersecting : false;
						bar.classList.toggle('at-footer', isIntersecting);
					},
					{ root: null, threshold: 0.01 }
				);

				footerObserver.observe(footerEl);
			}
			function applyOpenState() {
				const shouldOpen = window.scrollY >= openThreshold;
				if (shouldOpen) {
					bar.classList.add('open');
				} else {
					bar.classList.remove('open');
				}
			}
			function scheduleOpenSync() {
				if (openRaf) return;
				openRaf = window.requestAnimationFrame(function () {
					openRaf = 0;
					applyOpenState();
				});
			}

			computeOpenThreshold();
			applyOpenState();
			bindFooterObserver();

			document.addEventListener('scroll', scheduleOpenSync, { passive: true });
			window.addEventListener('resize', function () {
				computeOpenThreshold();
				bindFooterObserver();
				scheduleOpenSync();
			});
			try {
				const mq = window.matchMedia('(min-width: 1025px)');
				if (mq && mq.addEventListener) mq.addEventListener('change', bindFooterObserver);
				else if (mq && mq.addListener) mq.addListener(bindFooterObserver);
			} catch (e) {
				// no-op
			}

			function moveToMount(el, mount) {
				if (!el || !mount) return;
				if (el.parentElement === mount) return;
				mount.appendChild(el);
			}

			function restoreHome(el, home) {
				if (!el || !home || !home.parent) return;
				if (el.parentElement === home.parent) return;
				if (home.next && home.next.parentNode === home.parent) {
					home.parent.insertBefore(el, home.next);
				} else {
					home.parent.appendChild(el);
				}
			}

			function moveBarIntoForm() {
				if (!formEl) return;
				if (bar.closest('form') === formEl) return;
				formEl.appendChild(bar);
			}

			function restoreBarHome() {
				restoreHome(bar, barHome);
			}

			let colorVariantsUpdateRaf = 0;
			function scheduleColorVariantsCarouselUpdate() {
				if (colorVariantsUpdateRaf) return;
				colorVariantsUpdateRaf = window.requestAnimationFrame(function () {
					colorVariantsUpdateRaf = 0;
					if (!colorVariantsEl) return;
					const root = colorVariantsEl.querySelector('.product__meta__color-variants');
					if (!root) return;
					if (root._ymeeEmbla && typeof root._ymeeEmbla.reInit === 'function') {
						root._ymeeEmbla.reInit();
						return;
					}
					const swiper = root.swiper;
					if (swiper && typeof swiper.update === 'function') {
						swiper.update();
					}
				});
			}

			let lastOpen = null;
			function sync() {
				const mq = window.matchMedia('(min-width: 1025px)');
				const isDesktop = mq && mq.matches;
				if (!isDesktop) {
					lastOpen = null;
					restoreHome(colorVariantsEl, colorHome);
					restoreHome(resolveDropdown(), dropdownHome);
					restoreBarHome();
					scheduleColorVariantsCarouselUpdate();
					return;
				}

				const isOpen = bar.classList.contains('open');
				if (lastOpen === isOpen) return;
				lastOpen = isOpen;

				if (isOpen) {
					// Keep the sticky dropdown inside the real product form.
					// Shopify accelerated checkout buttons can break when their DOM is moved outside the form.
					moveBarIntoForm();
					moveToMount(colorVariantsEl, colorMount);
					moveToMount(resolveDropdown(), dropdownMount);
					scheduleColorVariantsCarouselUpdate();
				} else {
					restoreHome(colorVariantsEl, colorHome);
					restoreHome(resolveDropdown(), dropdownHome);
					restoreBarHome();
					scheduleColorVariantsCarouselUpdate();
				}
			}

			sync();

			try {
				new MutationObserver(function () {
					scheduleOpenSync();
					sync();
				}).observe(bar, { attributes: true, attributeFilter: ['class'] });
			} catch (e) {
				// no-op
			}
			document.addEventListener('scroll', sync, { passive: true });
			window.addEventListener('resize', sync);
		});
	}
	initStickyBar();

	function initColorVariantsEmbla(scope) {
		const Embla = window.EmblaCarousel || (typeof EmblaCarousel !== 'undefined' ? EmblaCarousel : null);
		if (!Embla) return;

		(scope || document).querySelectorAll('.product__meta__color-variants.embla').forEach((root) => {
			if (root.dataset.ymeeEmblaBound === 'true') {
				if (root._ymeeEmbla && typeof root._ymeeEmbla.reInit === 'function') root._ymeeEmbla.reInit();
				return;
			}
			root.dataset.ymeeEmblaBound = 'true';

			const viewport = root.querySelector('.embla__viewport');
			if (!viewport) return;

			try {
				if (root.swiper && typeof root.swiper.destroy === 'function') {
					root.swiper.destroy(true, true);
				}
			} catch (e) {
				// no-op
			}

			const embla = Embla(viewport, {
				loop: false,
				dragFree: true,
				containScroll: 'trimSnaps',
				align: 'start',
			});
			root._ymeeEmbla = embla;

			const slideNodes = Array.from(root.querySelectorAll('.embla__slide'));
			const updateSelected = () => {
				const idx = embla.selectedScrollSnap();
				slideNodes.forEach((n, i) => n.classList.toggle('is-selected', i === idx));
			};
			updateSelected();
			embla.on('select', updateSelected);
			embla.on('reInit', updateSelected);

			const prevBtn = root.querySelector('.product__meta__color-variants-arrow--left');
			const nextBtn = root.querySelector('.product__meta__color-variants-arrow--right');
			if (prevBtn) prevBtn.addEventListener('click', () => embla.scrollPrev());
			if (nextBtn) nextBtn.addEventListener('click', () => embla.scrollNext());
		});
	}
	initColorVariantsEmbla(document);
	document.addEventListener('shopify:section:load', function(e) {
		initColorVariantsEmbla(e.target);
	});

	function initColorVariantImageLoading(scope) {
		(scope || document)
			.querySelectorAll(
				'.product__meta__color-variants .product__meta__color-variants__variant figure img'
			)
			.forEach((img) => {
				if (img.dataset.ymeeLoadedBound === 'true') return;
				img.dataset.ymeeLoadedBound = 'true';
				const markLoaded = () => img.classList.add('is-loaded');
				if (img.complete && img.naturalWidth > 0) {
					markLoaded();
				} else {
					img.addEventListener('load', markLoaded, { once: true });
					img.addEventListener('error', markLoaded, { once: true });
				}
			});
	}
	initColorVariantImageLoading(document);
	document.addEventListener('shopify:section:load', function(e) {
		initColorVariantImageLoading(e.target);
	});

	(() => {
      const el = document.querySelector('[id^="ProductCollectionsJson-"]');
      if (!el) return;

      let collections;
      try {
        collections = JSON.parse(el.textContent || '{}');
      } catch (e) {
        return;
      }

      const titles = Array.isArray(collections?.titles) ? collections.titles : [];
      const hasTennis = titles.some((t) => typeof t === 'string' && t.toLowerCase().includes('tennis'));
      if (hasTennis) {
		const classes = ['header-white', 'permanent-white', 'pdp-tennis'];
		document.body.classList.add(...classes);
      }
    	})();

	function initMobileNavbarAddToCartFallback() {
		const btn = document.querySelector('[data-ymee-mobile-navbar-add-to-cart]');
		if (!btn) return;
		if (btn.dataset.ymeeBound === 'true') return;
		btn.dataset.ymeeBound = 'true';
		const legacySticky = document.querySelector('.product__form__sticky-bottom');
		const syncLegacySticky = function () {
			if (!legacySticky) return;
			let isMobile = false;
			try {
				isMobile = window.matchMedia('(max-width: 1024px)').matches;
			} catch (e) {
				return;
			}
			legacySticky.style.display = isMobile ? 'none' : '';
		};
		syncLegacySticky();
		window.addEventListener('resize', syncLegacySticky);

		btn.addEventListener(
			'click',
			function (e) {
				try {
					if (!window.matchMedia('(max-width: 1024px)').matches) return;
				} catch (err) {
					return;
				}

				e.preventDefault();
				e.stopPropagation();

				const formEl = document.querySelector('form[action*="/cart/add"]');
				if (!formEl) return;

				try {
					if (typeof formEl.requestSubmit === 'function') {
						formEl.requestSubmit();
						return;
					}
				} catch (err2) {
					// no-op
				}

				try {
					const realSubmit = formEl.querySelector('button[type="submit"], input[type="submit"]');
					if (realSubmit && typeof realSubmit.click === 'function') realSubmit.click();
				} catch (err3) {
					// no-op
				}
			},
			true
		);
	}

	initMobileNavbarAddToCartFallback();

	function findMainAddToCartButtonFromRadio(radioEl) {
		const formEl = radioEl ? radioEl.closest('form') || radioEl.form : null;
		const scope = formEl || document;
		let found = null;
		try {
			scope.querySelectorAll('[data-btn-add-to-cart]').forEach((btn) => {
				if (found) return;
				const id = btn.getAttribute('id') || '';
				if (!id || id.indexOf('AddToCart--') !== 0) return;
				if (id.split('--').length === 2) found = btn;
			});
		} catch (e) {
			// no-op
		}
		if (found) return found;

		let fallback = null;
		try {
			scope.querySelectorAll('button[type="submit"], input[type="submit"]').forEach((btn) => {
				if (fallback) return;
				if (btn.closest && btn.closest('.ymee-variant-dropdown__option')) return;
				fallback = btn;
			});
		} catch (e) {
			// no-op
		}
		return fallback;
	}

	function setAddToCartButtonLabel(btn, label) {
		if (!btn) return;
		if (typeof label !== 'string') label = String(label || '');

		// For input[type=submit], preserve by setting value.
		if (btn.tagName === 'INPUT') {
			btn.value = label;
			return;
		}

		// Preserve existing child elements (e.g., SVG icon) by only updating text nodes.
		let firstTextNode = null;
		try {
			btn.childNodes.forEach((node) => {
				if (!node || node.nodeType !== Node.TEXT_NODE) return;
				if (!node.nodeValue || !node.nodeValue.trim()) return;
				if (!firstTextNode) firstTextNode = node;
				else node.nodeValue = '';
			});
		} catch (e) {
			// no-op
		}

		if (firstTextNode) {
			firstTextNode.nodeValue = ' ' + label;
			return;
		}

		try {
			btn.appendChild(document.createTextNode(' ' + label));
		} catch (e) {
			// no-op
		}
	}

	const variantRadios = document.querySelectorAll('input[name="option1"]');
	if( variantRadios ) {
			
		variantRadios.forEach(radio => {
		
			radio.addEventListener('change', function () {
					
				if( this.checked ) {

					const selectedVariantId = this.value;
					const variantInventoryJsonElement = document.querySelector('[data-variantion-inventory]');
					if (!variantInventoryJsonElement) return;
					let variantInventoryData;
					try {
						variantInventoryData = JSON.parse(variantInventoryJsonElement.textContent || '{}');
					} catch (e) {
						return;
					}
					const currentVariant = variantInventoryData[selectedVariantId];
					const addToCartBtn = findMainAddToCartButtonFromRadio(this);
				
					if (currentVariant) {

						if (currentVariant.inventory_policy === 'continue' && currentVariant.available) { //deny

							document.getElementById('custom-preorder-label').style.display = 'block';
							if (addToCartBtn) {
								setAddToCartButtonLabel(addToCartBtn, 'Pre-Order');
							}
						} else {
								
							document.getElementById('custom-preorder-label').style.display = 'none';
								
							if (addToCartBtn) {
								if( !currentVariant.available ) {
									setAddToCartButtonLabel(addToCartBtn, window.theme.strings.backinStockText);
								} else {
									setAddToCartButtonLabel(addToCartBtn, window.theme.strings.addToCartText);
								}
							}
						}
					}
				}
			});
		
		});

		const checkedVarianRadio = document.querySelector('input[name="option1"]:checked');

		if( checkedVarianRadio ) {
			checkedVarianRadio.checked = true;
			checkedVarianRadio.dispatchEvent(new Event('change', { bubbles: true }));
		}
	}

	function initProductGalleryEmbla() {
		const galleries = Array.from(document.querySelectorAll('.product-gallery--embla.embla'));
		if (!galleries.length) return;

		const Embla = window.EmblaCarousel || (typeof EmblaCarousel !== 'undefined' ? EmblaCarousel : null);
		if (!Embla) return;

		const mediaQuery = window.matchMedia('(max-width: 1024px)');

		const initOne = (root, isMobile) => {
			const viewport = root.querySelector('.embla__viewport');
			const container = root.querySelector('.embla__container');
			if (!viewport || !container) return;

			const slides = Array.from(container.querySelectorAll('.embla__slide'));
			const prevBtn = root.querySelector('.embla__prev');
			const nextBtn = root.querySelector('.embla__next');
			const dotsWrap = root.querySelector('.embla__dots');

			const isSiblingSlider = root.classList.contains('sease-sibling-products__slider');

			if (root._ymeeEmbla) {
				root._ymeeEmbla.destroy();
				root._ymeeEmbla = null;
			}

			if (isSiblingSlider && !isMobile) {
				if (prevBtn) prevBtn.style.display = 'none';
				if (nextBtn) nextBtn.style.display = 'none';
				if (dotsWrap) dotsWrap.style.display = 'none';
				return;
			}

			const shouldLoop = isMobile && isSiblingSlider;

			if (prevBtn) prevBtn.style.display = slides.length > 1 ? '' : 'none';
			if (nextBtn) nextBtn.style.display = slides.length > 1 ? '' : 'none';
			if (dotsWrap) dotsWrap.style.display = slides.length > 1 ? '' : 'none';

			// Specific configurations for sibling slider vs product gallery
		const emblaOptions = isSiblingSlider ? {
			loop: shouldLoop,
			draggable: true, // Always draggable for smooth scrolling
			align: 'start',
			dragFree: true, // Free scrolling for smooth momentum
			containScroll: false, // No containment for smoother feel
			skipSnaps: true, // Skip snap points for smoother scroll
			watchResize: true,
			watchDrag: true,
			friction: 0.8, // Less friction for smoother momentum
			// Mobile-specific smooth settings
			...(isMobile && {
				wheelSleep: 500,
				dragThreshold: 10, // Lower threshold for easier dragging
				touchThreshold: 5, // Lower touch threshold
				touchAction: 'pan-y pinch-zoom'
			})
		} : {
			// Product gallery settings
			loop: shouldLoop,
			draggable: isMobile,
			align: 'start',
			dragFree: false,
			containScroll: shouldLoop ? false : 'trimSnaps',
			skipSnaps: false,
			watchResize: true,
			watchDrag: true,
		};

		const embla = Embla(viewport, emblaOptions);
			root._ymeeEmbla = embla;

			let dotNodes = [];
			const addDots = () => {
				if (!dotsWrap) return;
				dotsWrap.innerHTML = '';
				dotNodes = embla.scrollSnapList().map((_, i) => {
					const dot = document.createElement('button');
					dot.type = 'button';
					dot.className = 'embla__dot';
					dot.addEventListener('click', () => embla.scrollTo(i));
					dotsWrap.appendChild(dot);
					return dot;
				});
			};

			const update = () => {
				const selected = embla.selectedScrollSnap();
				dotNodes.forEach((dot, i) => dot.classList.toggle('is-selected', i === selected));
				if (prevBtn) prevBtn.disabled = !embla.canScrollPrev();
				if (nextBtn) nextBtn.disabled = !embla.canScrollNext();
			};

			addDots();
			update();
			embla.on('select', update);
			embla.on('reInit', () => {
				addDots();
				update();
			});

			if (prevBtn) prevBtn.onclick = () => {
				const inst = root._ymeeEmbla;
				if (inst) inst.scrollPrev();
			};
			if (nextBtn) nextBtn.onclick = () => {
				const inst = root._ymeeEmbla;
				if (inst) inst.scrollNext();
			};
		};

		const initAll = () => {
			galleries.forEach((root) => initOne(root, mediaQuery.matches));
		};

		const reInitAll = () => {
			galleries.forEach((root) => {
				if (root._ymeeEmbla) root._ymeeEmbla.reInit();
			});
		};

		if (!window._ymeeProductGalleryResizeBound) {
			window._ymeeProductGalleryResizeBound = true;
			let resizeTimeout;
			const onResize = () => {
				clearTimeout(resizeTimeout);
				resizeTimeout = setTimeout(reInitAll, 150);
			};
			window.addEventListener('resize', onResize);
			window.addEventListener('orientationchange', onResize);
		}

		initAll();
		if (mediaQuery.addEventListener) {
			mediaQuery.addEventListener('change', initAll);
		} else if (mediaQuery.addListener) {
			mediaQuery.addListener(initAll);
		}
	}
	initProductGalleryEmbla();
});